export default "__VITE_ASSET__Cip4g228__"